import { z } from 'zod'

import { addressSchema } from '~/components/smart-accounts/schemas/addressSchema'
import { memoSchema } from '~/components/smart-accounts/schemas/memoSchema'

export const baseTransactionSchema = z
  .object({
    calls: z.array(
      z.object({
        to: addressSchema,
        data: z.string(),
        value: z.bigint(),
      }),
    ),
    transactionId: z.string().optional(),
    isReview: z.boolean().optional(),
  })
  .and(memoSchema)
  .refine(
    (data) => {
      if (data.calls.length === 0) return false
      return true
    },
    {
      message: 'No transaction call data',
      path: ['calls'],
    },
  )

export type BaseTransactionFormValues = z.infer<typeof baseTransactionSchema>
